export const apiConstant = {
    branding: `/branding`,
    exhibitions_list: `/exhibition-tour`,
    languages: `/languages`,
    exhibition_details: `/exhibition-tour-details`,
    exhibition_tour_point_list: `/exhibition-tour-point`,
    exhibition_tour_point_details: `/exhibition-tour-point-details`,
    point_accession_numbers: `/point-accession-numbers`,
};